import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import CustomPropTypes from '../../customPropTypes'
import {noDecorators} from '../../utils'
import decorators from '../Product/OutfitProductsDecorator'

import CarouselWrapper from '../CarouselWrapper'
import Desktop from '../Desktop'
import Phone from '../Phone'
import Tablet from '../Tablet'

const ProductSetSlider = ({children}) => (
  <section
    className={classNames('product-set-slider', {
      'is--low-count-item-slider': children.length < 5,
    })}
  >
    <Phone>
      <CarouselWrapper
        cellAlign="center"
        cellSpacing={10}
        slideIndex={1}
        slideWidth="200px"
        {...noDecorators}
      >
        {children}
      </CarouselWrapper>
    </Phone>
    <Tablet>
      <CarouselWrapper
        cellAlign="center"
        cellSpacing={10}
        slideIndex={2}
        slideWidth="200px"
        {...noDecorators}
      >
        {children}
      </CarouselWrapper>
    </Tablet>
    <Desktop>
      <CarouselWrapper
        cellAlign="center"
        cellSpacing={10}
        slideIndex={2}
        slideWidth="170px"
        {...(children.length > 5 ? decorators : noDecorators)}
      >
        {children}
      </CarouselWrapper>
    </Desktop>
  </section>
)

ProductSetSlider.propTypes = {
  children: CustomPropTypes.children,
  eventName: PropTypes.string,
}

export default ProductSetSlider
